import { EHubMainReportMutations, } from './types';
const mutations = {
    [EHubMainReportMutations.SET_FILTER_OPTION]({ filterOption }, payload) {
        Object.entries(payload).forEach(([key, value,]) => {
            filterOption[key] = value;
        });
    },
    [EHubMainReportMutations.GET_HUB_MAIN_REPORT](state, report) {
        state.hubMainReport = report;
    },
    [EHubMainReportMutations.GET_SELECTED_HUB_INFO](state, hubInfo) {
        state.selectedHubInfo = hubInfo;
    },
    [EHubMainReportMutations.RESET_HUB_MAIN_REPORT](state) {
        state.hubMainReport = null;
    },
};
export default mutations;
